import React from 'react'
import PageConfig from '@/component/layout/PageConfig.tsx'
import { TYPE_TopNav } from '@/component/layout/TopNav/TopNav.tsx'
import Footer from '@/component/layout/Footer/Footer.tsx'

const LocationTermsPage: React.FC = () => {
    return (
        <PageConfig showTopNav={true} typeTopNav={TYPE_TopNav.GUIDE}>
            <div className={'section_800 py-[60px] md:py-[30px] px-[24px]'}>
                <h1 className={'text-[28px] md:text-[22px] font-bold mb-[32px]'}>위치기반서비스 이용약관</h1>

                <section className={'mb-[32px] p-[20px] border border-gray3 rounded-[8px] bg-gray1'}>
                    <h2 className={'text-[18px] font-bold mb-[12px]'}>위치기반서비스 이용약관 개정 안내</h2>
                    <p className={'text-[14px] text-gray4 leading-[1.8] mb-[12px]'}>
                        돌봄드림 주식회사는 위치정보법 준수 및 개인위치정보 보호 강화를 위하여 위치기반서비스 이용약관을 아래와 같이 개정합니다.
                    </p>
                    <ol className={'text-[14px] text-gray4 leading-[1.8] list-decimal pl-[20px]'}>
                        <li>
                            변경일시
                            <div className={'pl-[4px]'}>2026년 6월 22일</div>
                        </li>
                        <li>
                            시행일
                            <div className={'pl-[4px]'}>2026년 6월 22일</div>
                        </li>
                        <li>
                            변경사유
                            <div className={'pl-[4px]'}>개인위치정보 수집사실 확인자료의 보유근거 및 보유기간, 개인위치정보의 수집방법 등 위치기반서비스 이용약관 필수 명시사항을 명확히 반영하기 위함</div>
                        </li>
                        <li className={'mb-[8px]'}>
                            주요 변경내용
                            <ul className={'list-disc pl-[20px] mt-[4px]'}>
                                <li>개인위치정보 수집·이용·제공사실 확인자료의 보유근거 및 보유기간 명시</li>
                                <li>개인위치정보 수집사실 확인자료 및 이용·제공사실 확인자료의 보유기간 6개월 명시</li>
                                <li>개인위치정보의 수집방법 조항 신설</li>
                                <li>위치정보관리책임자 및 회사 주소 현행화</li>
                                <li>이용약관 변경내용, 변경사유 및 적용일자 공개 절차 보완</li>
                            </ul>
                        </li>
                        <li>
                            개정 약관 적용 대상
                            <div className={'pl-[4px]'}>Carearly 위치기반서비스 이용자</div>
                        </li>
                    </ol>
                </section>

                <section className={'mb-[28px]'}>
                    <h2 className={'text-[18px] font-bold mb-[12px]'}>제1조 (목적)</h2>
                    <p className={'text-[14px] text-gray4 leading-[1.8]'}>
                        본 약관은 회원(Carearly 서비스 약관에 동의한 개인위치정보주체를 말합니다. 이하 "회원"이라고 합니다)이 돌봄드림 주식회사(이하 "회사"라고 합니다)가 제공하는 Carearly 서비스 및 관련 위치기반서비스(이하 "서비스"라고 합니다)를 이용함에 있어 회사와 회원의 권리·의무 및 기타 필요한 사항을 규정함을 목적으로 합니다.
                    </p>
                </section>

                <section className={'mb-[28px]'}>
                    <h2 className={'text-[18px] font-bold mb-[12px]'}>제2조 (이용약관의 효력 및 변경)</h2>
                    <ol className={'text-[14px] text-gray4 leading-[1.8] list-decimal pl-[20px]'}>
                        <li>본 약관은 서비스를 신청한 고객 또는 개인위치정보주체가 본 약관에 동의하고 회사가 정한 절차에 따라 서비스 이용자로 등록함으로써 효력이 발생합니다.</li>
                        <li>회원이 온라인에서 본 약관의 "동의하기" 버튼을 클릭하거나 서비스 이용 과정에서 본 약관에 동의한 경우, 회원은 본 약관의 내용을 모두 읽고 이를 충분히 이해하였으며 그 적용에 동의한 것으로 봅니다.</li>
                        <li>회사는 위치기반서비스의 변경사항을 반영하기 위하여 필요한 경우 등에는 「위치정보의 보호 및 이용 등에 관한 법률」, 「개인정보 보호법」, 「콘텐츠산업 진흥법」, 「전자상거래 등에서의 소비자보호에 관한 법률」, 「소비자기본법」, 「약관의 규제에 관한 법률」 등 관련 법령을 위반하지 않는 범위에서 본 약관을 개정할 수 있습니다.</li>
                        <li className={'mb-[8px]'}>
                            회사가 약관을 개정할 경우에는 적용일자, 개정사유, 현행약관 및 개정약관의 주요 내용을 명시하여 다음 각 호의 방법으로 게시 및 통지합니다.
                            <ul className={'list-disc pl-[20px] mt-[4px]'}>
                                <li>서비스 홈페이지 또는 서비스 화면 게시 : 개정약관 적용일 30일 전부터 적용일 이후 상당한 기간</li>
                                <li>회원에게 전자적 형태로 개별 통지 : 전자우편, SMS, 앱 알림, 서비스 내 알림 등 회사가 보유한 연락수단을 통한 통지</li>
                            </ul>
                        </li>
                        <li>회사는 약관을 변경하는 경우 그 이유 및 변경내용을 회원이 쉽게 확인할 수 있도록 공개하며, 변경된 사항을 쉽게 알아볼 수 있도록 조치합니다.</li>
                        <li>회사의 전항에 따른 게시 및 통지 후에도 회원이 개정약관 적용일까지 개정약관에 대해 동의 또는 거부의 의사표시를 하지 않을 때에는 회원이 해당 개정약관에 동의한 것으로 봅니다.</li>
                        <li>회원이 개정약관에 동의하지 않을 경우 회사 또는 회원은 이용계약을 해지할 수 있습니다. 이 경우 회사는 계약 해지로 인하여 회원에게 손해가 발생한 경우 관련 법령에 따라 책임을 부담합니다.</li>
                    </ol>
                </section>

                <section className={'mb-[28px]'}>
                    <h2 className={'text-[18px] font-bold mb-[12px]'}>제3조 (관계법령의 적용)</h2>
                    <p className={'text-[14px] text-gray4 leading-[1.8]'}>
                        본 약관은 신의성실의 원칙에 따라 공정하게 적용하며, 본 약관에 명시되지 아니한 사항에 대하여는 관계 법령 또는 상관례에 따릅니다.
                    </p>
                </section>

                <section className={'mb-[28px]'}>
                    <h2 className={'text-[18px] font-bold mb-[12px]'}>제4조 (서비스의 내용, 개인위치정보의 보유목적 및 보유기간)</h2>
                    <ol className={'text-[14px] text-gray4 leading-[1.8] list-decimal pl-[20px]'}>
                        <li className={'mb-[8px]'}>
                            회사가 제공하는 위치기반서비스 및 개인위치정보의 보유목적과 보유기간은 다음과 같습니다.
                            <div className={'overflow-x-auto mt-[8px] mb-[8px]'}>
                                <table className={'w-full border-collapse border border-gray3 text-[13px]'}>
                                    <thead>
                                        <tr className={'bg-gray1'}>
                                            <th className={'border border-gray3 px-[12px] py-[8px] text-left'}>서비스 명</th>
                                            <th className={'border border-gray3 px-[12px] py-[8px] text-left'}>서비스 내용 및 보유목적</th>
                                            <th className={'border border-gray3 px-[12px] py-[8px] text-left'}>개인위치정보 보유기간</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td className={'border border-gray3 px-[12px] py-[8px]'}>Carearly 위치기반서비스</td>
                                            <td className={'border border-gray3 px-[12px] py-[8px]'}>보호 대상자의 현재 위치 확인, 이동 경로 확인, 낙상 감지 및 위험 상황 알림, 보호자 및 관리자의 위치 기반 돌봄 지원, 안전관리 및 응급상황 대응</td>
                                            <td className={'border border-gray3 px-[12px] py-[8px]'}>서비스 이용 종료 시까지. 다만, 다른 법률에 따라 보유하여야 하거나 회원이 개인위치정보의 보유에 별도로 동의한 경우에는 해당 법률 또는 별도 동의 범위 내에서 최대 1년간 보유할 수 있습니다.</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </li>
                        <li>회사는 「위치정보의 보호 및 이용 등에 관한 법률」 제16조제2항에 따라 개인위치정보의 수집·이용·제공사실 확인자료를 위치정보시스템에 자동으로 기록·보존합니다.</li>
                        <li className={'mb-[8px]'}>
                            회사가 기록·보존하는 개인위치정보 수집·이용·제공사실 확인자료의 보유근거 및 보유기간은 다음과 같습니다.
                            <div className={'overflow-x-auto mt-[8px] mb-[8px]'}>
                                <table className={'w-full border-collapse border border-gray3 text-[13px]'}>
                                    <thead>
                                        <tr className={'bg-gray1'}>
                                            <th className={'border border-gray3 px-[12px] py-[8px] text-left'}>구분</th>
                                            <th className={'border border-gray3 px-[12px] py-[8px] text-left'}>보유근거</th>
                                            <th className={'border border-gray3 px-[12px] py-[8px] text-left'}>보유기간</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td className={'border border-gray3 px-[12px] py-[8px]'}>개인위치정보 수집사실 확인자료</td>
                                            <td className={'border border-gray3 px-[12px] py-[8px]'}>「위치정보의 보호 및 이용 등에 관한 법률」 제16조제2항</td>
                                            <td className={'border border-gray3 px-[12px] py-[8px]'}>6개월</td>
                                        </tr>
                                        <tr>
                                            <td className={'border border-gray3 px-[12px] py-[8px]'}>개인위치정보 이용·제공사실 확인자료</td>
                                            <td className={'border border-gray3 px-[12px] py-[8px]'}>「위치정보의 보호 및 이용 등에 관한 법률」 제16조제2항</td>
                                            <td className={'border border-gray3 px-[12px] py-[8px]'}>6개월</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </li>
                        <li>회사는 개인위치정보의 이용 또는 제공목적을 달성한 때에는 제3항의 수집·이용·제공사실 확인자료를 제외한 개인위치정보를 지체 없이 파기합니다. 다만, 다른 법률에 따라 보유하여야 하거나 회원이 개인위치정보의 보유에 별도로 동의한 경우에는 해당 법률 또는 별도 동의 범위 내에서 보유할 수 있습니다.</li>
                    </ol>
                </section>

                <section className={'mb-[28px]'}>
                    <h2 className={'text-[18px] font-bold mb-[12px]'}>제5조 (개인위치정보의 수집방법)</h2>
                    <ol className={'text-[14px] text-gray4 leading-[1.8] list-decimal pl-[20px]'}>
                        <li className={'mb-[8px]'}>
                            회사는 서비스 제공을 위하여 다음 각 호의 방법으로 개인위치정보를 수집합니다.
                            <ul className={'list-disc pl-[20px] mt-[4px]'}>
                                <li>회원 또는 보호 대상자가 사용하는 스마트폰, 웨어러블 기기, IoT 디바이스 등 위치정보 수집 기능이 있는 단말기를 통한 수집</li>
                                <li>GPS, Wi-Fi, 기지국 정보(Cell-ID), IP 기반 위치정보, 그 밖에 단말기 및 통신망에서 제공하는 위치 측위 정보를 통한 수집</li>
                                <li>회사의 디바이스 또는 애플리케이션이 서버와 통신하는 과정에서 UDP, MQTT, HTTPS 등 통신방식을 통해 전송되는 위치정보의 수집</li>
                                <li>회원이 서비스 이용 과정에서 위치정보 수집에 동의한 후 서비스 화면, 관제 시스템, 보호자 연동 기능 등을 통해 이루어지는 위치정보의 수집</li>
                            </ul>
                        </li>
                        <li>회사는 서비스 제공에 필요한 최소한의 범위에서 개인위치정보를 수집합니다.</li>
                        <li>회원은 제11조에 따라 개인위치정보 이용 또는 제공의 일시적인 중지를 요구할 수 있습니다.</li>
                    </ol>
                </section>

                <section className={'mb-[28px]'}>
                    <h2 className={'text-[18px] font-bold mb-[12px]'}>제6조 (서비스 이용요금 및 조건)</h2>
                    <ol className={'text-[14px] text-gray4 leading-[1.8] list-decimal pl-[20px]'}>
                        <li>회사가 제공하는 서비스는 기본적으로 무료입니다.</li>
                        <li>향후 유료서비스가 제공될 경우 해당 서비스 화면 또는 홈페이지에서 이용요금을 별도로 안내합니다.</li>
                        <li>이동통신망 이용 시 발생하는 데이터 통신료는 회원이 가입한 이동통신사의 정책에 따릅니다.</li>
                    </ol>
                </section>

                <section className={'mb-[28px]'}>
                    <h2 className={'text-[18px] font-bold mb-[12px]'}>제7조 (서비스 추가·변경)</h2>
                    <p className={'text-[14px] text-gray4 leading-[1.8]'}>
                        회사가 서비스의 추가·변경이 필요한 경우, 제4조 및 관련 조항에 그 내용을 반영하고 제2조에 따라 변경내용, 변경사유 및 적용일자를 게시 및 통지합니다.
                    </p>
                </section>

                <section className={'mb-[28px]'}>
                    <h2 className={'text-[18px] font-bold mb-[12px]'}>제8조 (서비스 이용의 제한 및 중지)</h2>
                    <ol className={'text-[14px] text-gray4 leading-[1.8] list-decimal pl-[20px]'}>
                        <li className={'mb-[8px]'}>
                            회사는 아래 각 호의 어느 하나에 해당하는 사유가 발생한 경우 서비스의 일부 또는 전부의 이용을 제한하거나 중지할 수 있습니다.
                            <ul className={'list-disc pl-[20px] mt-[4px]'}>
                                <li>회원이 서비스 운영을 고의로 방해하는 경우</li>
                                <li>시스템 점검, 서버 장애, 통신 장애, 보안 사고 등 서비스 운영상 필요한 경우</li>
                                <li>국가비상사태, 천재지변, 정전, 통신망 장애 등 불가항력 상황이 발생한 경우</li>
                                <li>기타 서비스 운영상 중대한 사유가 발생한 경우</li>
                            </ul>
                        </li>
                        <li>회사는 전항의 규정에 따라 서비스의 이용을 제한하거나 중지한 때에는 그 사유 및 제한기간 등을 서비스 홈페이지, 서비스 화면, 전자우편, SMS, 앱 알림 등으로 게시 또는 통지합니다.</li>
                        <li>회사가 전항에 따른 게시 또는 통지를 할 수 없는 부득이한 사유가 있는 경우에는 사후에 게시 또는 통지할 수 있습니다.</li>
                    </ol>
                </section>

                <section className={'mb-[28px]'}>
                    <h2 className={'text-[18px] font-bold mb-[12px]'}>제9조 (개인위치정보의 이용 또는 제공)</h2>
                    <ol className={'text-[14px] text-gray4 leading-[1.8] list-decimal pl-[20px]'}>
                        <li>회사는 개인위치정보를 이용하여 서비스를 제공하고자 하는 경우에는 미리 본 약관에 명시한 후 개인위치정보주체의 동의를 얻습니다.</li>
                        <li>회사는 개인위치정보를 회원이 지정하는 제3자에게 제공하는 경우에는 제공받는 자, 제공목적, 제공항목, 제공기간을 사전에 회원에게 고지하고 동의를 받습니다.</li>
                        <li>회사가 제2항에 따라 개인위치정보를 회원이 지정하는 제3자에게 제공하는 경우에는 개인위치정보를 수집한 해당 통신단말장치 또는 회원이 미리 지정한 전자우편주소 등으로 매회 회원에게 제공받는 자, 제공일시 및 제공목적을 즉시 통보합니다.</li>
                        <li className={'mb-[8px]'}>
                            단, 아래 각 호에 해당하는 경우에는 회원이 미리 특정하여 지정한 통신단말장치 또는 전자우편주소 등으로 통보합니다.
                            <ul className={'list-disc pl-[20px] mt-[4px]'}>
                                <li>개인위치정보를 수집한 해당 통신단말장치가 문자, 음성 또는 영상의 수신기능을 갖추지 아니한 경우</li>
                                <li>회원이 개인위치정보를 수집한 해당 통신단말장치 외의 통신단말장치 또는 전자우편주소 등으로 통보할 것을 미리 요청한 경우</li>
                            </ul>
                        </li>
                        <li>제3항에도 불구하고 회원은 관련 법령에 따라 정보제공내역을 모아서 통보받는 방법을 선택할 수 있으며, 회원이 회사의 절차에 따라 요청할 경우 즉시 통보 방법으로 변경할 수 있습니다.</li>
                        <li>회원은 제1항, 제2항 및 제5항에 따른 동의를 하는 경우 이용·제공목적, 제공받는 자의 범위, 위치기반서비스 이용약관의 내용 중 일부 및 개인위치정보 제3자 제공 시 통보방법에 대하여 동의를 유보할 수 있습니다.</li>
                    </ol>
                </section>

                <section className={'mb-[28px]'}>
                    <h2 className={'text-[18px] font-bold mb-[12px]'}>제10조 (개인위치정보의 이용 또는 제공의 제한)</h2>
                    <p className={'text-[14px] text-gray4 leading-[1.8] mb-[8px]'}>
                        회사는 회원의 동의가 있거나 다음 각 호의 어느 하나에 해당하는 경우를 제외하고는 개인위치정보 또는 위치정보 수집·이용·제공사실 확인자료를 본 약관에 명시 또는 고지한 범위를 넘어 이용하거나 제3자에게 제공하지 않습니다.
                    </p>
                    <ol className={'text-[14px] text-gray4 leading-[1.8] list-decimal pl-[20px]'}>
                        <li>위치기반서비스의 제공에 따른 요금정산을 위하여 위치정보 이용·제공사실 확인자료가 필요한 경우</li>
                        <li>통계작성, 학술연구 또는 시장조사를 위하여 특정 개인을 알아볼 수 없는 형태로 가공하여 제공하는 경우</li>
                        <li>다른 법률에 특별한 규정이 있는 경우</li>
                    </ol>
                </section>

                <section className={'mb-[28px]'}>
                    <h2 className={'text-[18px] font-bold mb-[12px]'}>제11조 (개인위치정보주체의 권리 및 행사방법)</h2>
                    <ol className={'text-[14px] text-gray4 leading-[1.8] list-decimal pl-[20px]'}>
                        <li>회원은 회사에 대하여 언제든지 개인위치정보를 이용한 위치기반서비스 제공 및 개인위치정보의 제3자 제공에 대한 동의의 전부 또는 일부를 철회할 수 있습니다.</li>
                        <li>회원이 동의의 전부를 철회한 경우 회사는 수집한 개인위치정보 및 위치정보 수집·이용·제공사실 확인자료를 지체 없이 파기합니다. 단, 동의의 일부를 철회하는 경우에는 철회하는 부분의 개인위치정보 및 위치정보 수집·이용·제공사실 확인자료에 한합니다. 다만, 관련 법령에 따라 보관하여야 하는 자료는 해당 법령에서 정한 기간 동안 보관할 수 있습니다.</li>
                        <li>회원은 회사에 대하여 언제든지 개인위치정보의 이용 또는 제공의 일시적인 중지를 요구할 수 있고, 회사는 이를 거절할 수 없으며 이를 위한 기술적 수단을 갖추고 있습니다.</li>
                        <li className={'mb-[8px]'}>
                            회원은 회사에 대하여 아래 각 호의 자료에 대한 열람 또는 고지를 요구할 수 있고, 해당 자료에 오류가 있는 경우에는 그 정정을 요구할 수 있습니다. 이 경우 회사는 정당한 사유 없이 회원의 요구를 거절하지 않습니다.
                            <ul className={'list-disc pl-[20px] mt-[4px]'}>
                                <li>본인에 대한 위치정보 수집·이용·제공사실 확인자료</li>
                                <li>본인의 개인위치정보가 「위치정보의 보호 및 이용 등에 관한 법률」 또는 다른 법률에 따라 제3자에게 제공된 이유 및 내용</li>
                            </ul>
                        </li>
                        <li>회원은 제1항부터 제4항까지의 권리행사를 위해 고객센터 또는 회사의 연락처를 통해 요구할 수 있습니다.</li>
                    </ol>
                </section>

                <section className={'mb-[28px]'}>
                    <h2 className={'text-[18px] font-bold mb-[12px]'}>제12조 (법정대리인의 권리 및 행사방법)</h2>
                    <ol className={'text-[14px] text-gray4 leading-[1.8] list-decimal pl-[20px]'}>
                        <li>회사는 14세 미만 회원의 개인위치정보를 이용한 위치기반서비스 제공 및 개인위치정보의 제3자 제공에 대하여 해당 회원과 그 법정대리인 모두의 동의를 받아야 합니다. 이 경우 법정대리인은 제11조에 따른 회원의 권리를 모두 가집니다.</li>
                        <li className={'mb-[8px]'}>
                            회사는 다음 각 호의 어느 하나에 해당하는 방법으로 법정대리인이 동의했는지를 확인합니다.
                            <ul className={'list-disc pl-[20px] mt-[4px]'}>
                                <li>동의 내용을 게재한 인터넷 사이트에 법정대리인이 동의 여부를 표시하도록 하고, 회사가 그 동의 표시를 확인했음을 법정대리인의 휴대전화 문자메시지로 알리는 방법</li>
                                <li>동의 내용을 게재한 인터넷 사이트에 법정대리인이 동의 여부를 표시하도록 하고, 법정대리인의 신용카드·직불카드 등의 카드정보를 제공받는 방법</li>
                                <li>동의 내용을 게재한 인터넷 사이트에 법정대리인이 동의 여부를 표시하도록 하고, 법정대리인의 휴대전화 본인인증 등을 통해 본인 여부를 확인하는 방법</li>
                                <li>동의 내용이 적힌 서면을 법정대리인에게 직접 발급하거나 우편 또는 팩스를 통하여 전달하고, 법정대리인이 동의 내용에 대하여 서명날인 후 제출하도록 하는 방법</li>
                                <li>동의 내용이 적힌 전자우편을 발송하여 법정대리인으로부터 동의의 의사표시가 적힌 전자우편을 전송받는 방법</li>
                                <li>전화를 통하여 동의 내용을 법정대리인에게 알리고 동의를 얻거나, 인터넷주소 등 동의 내용을 확인할 수 있는 방법을 안내하고 재차 전화 통화를 통하여 동의를 얻는 방법</li>
                                <li>그 밖에 제1호부터 제6호까지의 방법에 준하는 방법으로 법정대리인에게 동의 내용을 알리고 동의의 의사표시를 확인하는 방법</li>
                            </ul>
                        </li>
                    </ol>
                </section>

                <section className={'mb-[28px]'}>
                    <h2 className={'text-[18px] font-bold mb-[12px]'}>제13조 (8세 이하의 아동 등의 보호의무자의 권리·의무 및 행사방법)</h2>
                    <ol className={'text-[14px] text-gray4 leading-[1.8] list-decimal pl-[20px]'}>
                        <li className={'mb-[8px]'}>
                            회사는 아래 각 호의 어느 하나에 해당하는 자(이하 "8세 이하의 아동 등"이라 합니다)의 보호의무자가 8세 이하의 아동 등의 생명 또는 신체의 보호를 위하여 개인위치정보의 이용 또는 제공에 동의하는 경우에는 본인의 동의가 있는 것으로 봅니다.
                            <ul className={'list-disc pl-[20px] mt-[4px]'}>
                                <li>8세 이하의 아동</li>
                                <li>피성년후견인</li>
                                <li>「장애인복지법」 제2조제2항제2호에 따른 정신적 장애를 가진 사람으로서 「장애인고용촉진 및 직업재활법」 제2조제2호에 따른 중증장애인에 해당하는 사람</li>
                            </ul>
                        </li>
                        <li className={'mb-[8px]'}>
                            제1항에 따른 보호의무자는 8세 이하의 아동 등을 사실상 보호하는 자로서 다음 각 호의 어느 하나에 해당하는 자를 말합니다.
                            <ul className={'list-disc pl-[20px] mt-[4px]'}>
                                <li>8세 이하의 아동의 법정대리인 또는 「보호시설에 있는 미성년자의 후견 직무에 관한 법률」 제3조에 따른 후견인</li>
                                <li>피성년후견인의 법정대리인</li>
                                <li>제1항제3호에 해당하는 사람의 법정대리인 또는 관련 법령에 따른 보호시설의 장</li>
                            </ul>
                        </li>
                        <li className={'mb-[8px]'}>
                            제1항에 따른 동의를 하고자 하는 보호의무자는 다음 각 호의 사항을 기재하여 기명날인 또는 서명한 서면동의서에 보호의무자임을 증명하는 서면을 첨부하여 회사에 제출하여야 합니다.
                            <ul className={'list-disc pl-[20px] mt-[4px]'}>
                                <li>8세 이하의 아동 등의 성명, 주소 및 생년월일</li>
                                <li>보호의무자의 성명, 주소 및 연락처</li>
                                <li>개인위치정보 이용 또는 제공의 목적이 8세 이하의 아동 등의 생명 또는 신체의 보호에 한정된다는 사실</li>
                                <li>동의의 연월일</li>
                            </ul>
                        </li>
                        <li>보호의무자는 8세 이하의 아동 등의 개인위치정보 이용 또는 제공에 동의하는 경우 제11조에 따른 회원의 권리를 모두 행사할 수 있습니다.</li>
                    </ol>
                </section>

                <section className={'mb-[28px]'}>
                    <h2 className={'text-[18px] font-bold mb-[12px]'}>제14조 (위치정보관리책임자의 지정)</h2>
                    <ol className={'text-[14px] text-gray4 leading-[1.8] list-decimal pl-[20px]'}>
                        <li>회사는 위치정보를 적절히 관리·보호하고 개인위치정보주체의 불만을 원활히 처리할 수 있도록 실질적인 책임을 질 수 있는 지위에 있는 자를 위치정보관리책임자로 지정하여 운영합니다.</li>
                        <li className={'mb-[8px]'}>
                            회사의 위치정보관리책임자는 다음과 같습니다.
                            <ul className={'list-disc pl-[20px] mt-[4px]'}>
                                <li>성명 : 김석현</li>
                                <li>직책 : CTO</li>
                                <li>대표전화 : 070-4452-5300</li>
                                <li>전자우편 : bruno@dolbomdream.com</li>
                            </ul>
                        </li>
                    </ol>
                </section>

                <section className={'mb-[28px]'}>
                    <h2 className={'text-[18px] font-bold mb-[12px]'}>제15조 (손해배상)</h2>
                    <p className={'text-[14px] text-gray4 leading-[1.8]'}>
                        회사가 「위치정보의 보호 및 이용 등에 관한 법률」 등 관련 법령을 위반한 행위로 회원에게 손해가 발생한 경우, 회원은 회사에 대하여 손해배상을 청구할 수 있습니다. 이 경우 회사는 고의 또는 과실이 없음을 입증하지 못하는 경우 책임을 면할 수 없습니다.
                    </p>
                </section>

                <section className={'mb-[28px]'}>
                    <h2 className={'text-[18px] font-bold mb-[12px]'}>제16조 (준거법 및 재판관할)</h2>
                    <ol className={'text-[14px] text-gray4 leading-[1.8] list-decimal pl-[20px]'}>
                        <li>본 약관은 대한민국 법령에 따라 규정되고 이행됩니다.</li>
                        <li>회원 및 법정대리인의 권리와 그 행사방법은 제소 당시 회원의 주소에 의하며, 주소가 없는 경우에는 거소를 관할하는 지방법원을 관할법원으로 합니다. 다만, 제소 당시 회원의 주소 또는 거소가 분명하지 않거나 외국 거주자의 경우에는 「민사소송법」에 따른 관할법원에 제기합니다.</li>
                    </ol>
                </section>

                <section className={'mb-[28px]'}>
                    <h2 className={'text-[18px] font-bold mb-[12px]'}>제17조 (분쟁의 조정 및 기타)</h2>
                    <ol className={'text-[14px] text-gray4 leading-[1.8] list-decimal pl-[20px]'}>
                        <li>회사는 위치정보와 관련된 분쟁에 대해 당사자 간 협의가 이루어지지 아니하거나 협의를 할 수 없는 경우에는 「위치정보의 보호 및 이용 등에 관한 법률」에 따라 방송미디어통신위원회에 재정을 신청할 수 있습니다.</li>
                        <li>회사 또는 회원은 위치정보와 관련된 분쟁에 대해 당사자 간 협의가 이루어지지 아니하거나 협의를 할 수 없는 경우에는 「개인정보 보호법」에 따라 개인정보분쟁조정위원회에 조정을 신청할 수 있습니다.</li>
                    </ol>
                </section>

                <section className={'mb-[28px]'}>
                    <h2 className={'text-[18px] font-bold mb-[12px]'}>제18조 (회사의 연락처)</h2>
                    <div className={'text-[14px] text-gray4 leading-[1.8]'}>
                        <p>회사의 상호, 대표자, 주소 및 연락처는 다음과 같습니다.</p>
                        <p className={'mt-[8px]'}>상호 : 돌봄드림 주식회사</p>
                        <p>대표자 : 김지훈</p>
                        <p>주소 : 대전광역시 중구 중앙로 119, 디스테이션 1003호(선화동)</p>
                        <p>대표전화 : 070-4452-5300</p>
                        <p>전자우편 : dev@dolbomdream.com</p>
                        <p>홈페이지 : https://dolbomdream.com/</p>
                    </div>
                </section>

                <section className={'mb-[28px]'}>
                    <h2 className={'text-[18px] font-bold mb-[12px]'}>부칙</h2>
                    <p className={'text-[14px] text-gray4 leading-[1.8]'}>
                        제1조 (시행일) 이 약관은 2026년 6월 22일부터 시행합니다.
                    </p>
                    <p className={'text-[14px] text-gray4 leading-[1.8] mt-[8px]'}>
                        제2조 (기존 약관의 개정) 본 약관 시행일 이전의 위치기반서비스 이용약관은 본 약관으로 대체됩니다.
                    </p>
                    <p className={'text-[14px] text-gray4 leading-[1.8] mt-[8px]'}>
                        제3조 (위치정보관리책임자) 2026년 6월 22일 기준 회사의 위치정보관리책임자는 다음과 같습니다.
                    </p>
                    <div className={'text-[14px] text-gray4 leading-[1.8] pl-[20px] mt-[4px]'}>
                        <p>성명 : 김석현</p>
                        <p>직책 : CTO</p>
                        <p>대표전화 : 070-4452-5300</p>
                        <p>전자우편 : bruno@dolbomdream.com</p>
                    </div>
                </section>
            </div>
            <Footer />
        </PageConfig>
    )
}

export default LocationTermsPage
